( function( $ ) {

	// Update the site logo in real time...
	// wp.customize( 'jora_logo', function( value ) {
	// 	value.bind( function( newval ) {
	// 		if (newval) {
	// 			$( '.jora-logo' ).html( '<img src="'+newval+'" alt=""/>' );
	// 		} else {
	// 			$( '.jora-logo' ).html( '' );
	// 		}
	// 	} );
	// } );

} )( jQuery );
